(function () {

  
  
  // 初始化下拉菜单
  mwLibs.paginationUtils.initDropdown();

  // 初始化分页功能
  mwLibs.paginationUtils.initPagination();

})();
